export const LOGIN_CODE = 'saagie.form.login';
export const PASSWORD_CODE = 'saagie.form.password';
export const GENERIC_CODE = 'saagie.generic';
